"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.TYPES = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
require("./style.scss");
exports.TYPES = Object.freeze({
    ROUTER_LINK: 'router',
    A_TAG: 'aTag',
    ON_CLICK: 'default',
});
// we'll be a bit strict here - we'll throw an error if any non-supported prop is passed to Link
const allowedProps = new Set(['type', 'to', 'children', 'onClick', 'key']);
const Link = (props) => {
    const { type, to, children, onClick } = props;
    const extraProps = Object.keys(props).filter(p => !allowedProps.has(p));
    if (extraProps.length > 0) {
        throw new Error(`Link component received unsupported props: ${extraProps.join(', ')}`);
    }
    if (type === exports.TYPES.ROUTER_LINK && to) {
        return (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: 'link' }, children));
    }
    if (type === exports.TYPES.A_TAG && to) {
        return (react_1.default.createElement("a", { href: to, target: '_blank', rel: 'noopener noreferrer', className: 'link' }, children));
    }
    return (react_1.default.createElement("div", { onClick: onClick, className: 'link' }, children));
};
exports.Link = Link;
Link.TYPES = exports.TYPES;
